

<!-- Header Section -->
<div class="page-header col-md-12 p-3">
    <div class="row">
      <div class="col-md-4">
        <h3 class="page-title" translate>Create Appointment</h3>
        <ol class="breadcrumb bg-white p-0">
          <li class="breadcrumb-item active" aria-current="page">New Appointment</li>
        </ol>
      </div>
      
  
      <!-- Mobile Dropdown -->
      <div class="col-12 d-flex d-md-none justify-content-end">
        <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">

  </div>
  </div>
  </div>
  </div>











<div class="row px-3 mt-2">
    <div class="d-flex flex-column justify-content-between row w-100 m-0">
  
  <!--{{questionaireForm.value | json}}-->
  
      <div class="p-0 bg-white shadow-sm rounded-lg">
          <div class="px-5 mx-5">
              <div class="row">
                  <div class="col-md-12 p-0 px-5">
  
                      <form [formGroup]="questionaireForm" class="text-center border border-light p-4  rounded-lg">
  
                          <div class="mb-4 pb-2 border-bottom">
                              <h3 class="mb-2 p-2 text-primary" style="font-family:'DINPro'" translate>Please complete the following questionnaire</h3>
                              <p class="text-danger p-2 small" style="font-family:'DINPro'" translate>* mandatory fields</p>
                          </div>
  
                          <div class="float-right w-100">
                            
                          </div>
                          <br>
                          <!-- {{registerForm.value | json}}-->
                          <div class="mx-1 bg-light">
                          <!-- Status and Request Type Section -->
                          <div class="row  d-flex justify-content-between mx-1 bg-light">
                              <div class="col-md-5 form-group py-2">
                                  <label translate class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start; font-family:'DINPro'">Status</label>
                                  <select class="form-control form-select select2tag select2-hidden-accessible"
                                      formControlName="status" id="status" name="status" style="width: 100%;"
                                      tabindex="-1" aria-hidden="true" [class.is-invalid]="formErrors.status"
                                      (blur)="logValidationErrors(questionaireForm)">
                                      <option value='' translate>SELECT</option>
                                      <option value="In Progress">In Progress</option>
                                      <option value="Pending">Pending</option>
                                      <option value="Completed">Completed</option>
                                      <option value="Cancelled">Cancelled</option>
                                      <option value="No Show">No Show</option> 
                                      
                                  </select>
                                  <div [class.d-none]="!formErrors.status">
                                      <small class="text-danger">{{formErrors.status}}</small></div>
                              </div>
  
  
                              <div class="col-md-5 form-group py-2">
                                
                                  <label translate class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start; font-family:'DINPro'">Request Type</label>
                                  <select class="form-control form-select select2tag select2-hidden-accessible"
                                      formControlName="requestType" id="requestType" name="requestType" 
                                      tabindex="-1" aria-hidden="true" 
                                     >
                                      <option value='Appointment'>Appointment</option>
                                      <option value="Browsing">Browsing</option> 
                                      <option value="Euro Lagno">Euro Lagno</option> 
                                      <option value="Walk-In">Walk-In</option>
                                      <option value="Online">Online</option>
                                      <option value="Phone">Phone</option>
                                      <option value="Email">Email</option>
                                      <option value="Previous">Previous</option> 
                                      <option value="Virtual Appointment">Virtual Appointment</option>
                                      <option value="Virtual Inquiry">Virtual Inquiry</option>
  
                                      
                                  </select>
  
                              </div>
  
                          </div>
  
                          <!-- Time In/Out Section -->
                          <div class="row  d-flex justify-content-between m-2  bg-light">
                    
                             
                              <div class="col-md-5 form-group py-2">
                                
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" for="timeIn" translate>Time In</label>
                                  <app-date-time-picker formControlName="timeIn" name="timeIn" class="w-100"></app-date-time-picker>   
                              </div>
  
  
                              <div class="col-md-5 form-group py-2">
                                
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" for="timeOut" translate>Time Out</label>
                                  <app-date-time-picker formControlName="timeOut" name="timeOut" class="w-100"></app-date-time-picker>   
                              </div>
  
                              
                       <!--       <div class="col-md-5 form-group py-2 mx-1">
                                
                                 <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Time Out</label>
                                 <div class="     d-flex justify-content-around">
                                 <input type="text " formControlName="timeOut" class="form-control  float-left  " style="width: 72%;"
                                    />
                                   <button class="btn btn-dark " (click)=patchCheckOut()>Check Out</button>
                                </div>
  
                             </div> -->
                          </div>
                        </div>
  
                          
             <!--             <div class="dropdown">
                              <a class="dropdown-toggle" id="dropdown2" role="button" data-toggle="dropdown" data-target="#" href="#">
                                <div class="input-group"><input type="text" class="form-control" formControlName="timeOut" data-ng-model="data.dateDropDownInput"><span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span>
                                </div>
                              </a>
                              <ul class="dropdown-menu" role="menu" aria-labelledby="dLabel">
                          
                                  <dl-date-time-picker 
                                  startView="day"
                                  maxView="year"
                                  minView="minute"
                                  minuteStep="15"
                                  [(ngModel)]="checkInDate"
                              >
                              </dl-date-time-picker>
                              </ul>
                            </div>-->
  
  
  
                      
  
  <!-- Pulsing Dots Spinner Overlay -->
  <div *ngIf="loading" class="spinner-overlay">
      <div class="dots-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
      </div>
  </div>
  
                          <!-- Personal Information Section -->
                          <div class="mt-4 mb-3 p-2 bg-light rounded">
                              <h5 class="text-primary mb-3" style="font-family:'DINPro'">Personal Information</h5>
                              
                              <div class="row w-100 d-flex justify-content-between p-2">
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Full
                                          Name <i class="text-danger">*</i></label>
                                      <input type="text" formControlName="fullName" class="form-control rounded-pill"
                                          [class.is-invalid]="formErrors.fullName"
                                          (blur)="logValidationErrors(questionaireForm)" />
  
                                      <div [class.d-none]="!formErrors.fullName">
                                          <small class="text-danger float-right" translate>{{formErrors.fullName}}</small></div>
                                  </div>
  
  
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Clientele</label>
                                      <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                          formControlName="clientele" id="clientele" name="clientele" style="width: 100%;"
                                          tabindex="-1" aria-hidden="true" 
                                       >
                                          
                                          <option value="Male">Male</option>
                                          <option value="Female">Female</option>
                                          <option value="Group">Group</option>
                                          <option value="Couple">Couple</option>
                                          <option value="Family">Family</option>
                                          
                                      </select>
                                  </div>
                              </div>
  
  
                              <div class="row w-100 d-flex justify-content-between p-2">
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Email</label>
                                      <input type="text" formControlName="email" class="form-control rounded-pill"
                                          [class.is-invalid]="formErrors.email"
                                          (blur)="logValidationErrors(questionaireForm)" />
  
                                      <div [class.d-none]="!formErrors.email">
                                          <small class="text-danger float-right" translate>{{formErrors.email}}</small></div>
                                  </div>
  
                                  <script>
                                      $(function () {
                          
                                          $('#phoneNumber').keydown(function (e) {
                                             var key = e.charCode || e.keyCode || 0;
                                             $text = $(this); 
                                             if (key !== 8 && key !== 9) {
                                                 if ($text.val().length === 3) {
                                                     $text.val($text.val() + '-');
                                                 }
                                                 if ($text.val().length === 7) {
                                                     $text.val($text.val() + '-');
                                                 }
                                      
                                             }
                                      
                                             return (key == 8 || key == 9 || key == 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105));
                                         })
                                      });
                                  </script>
                          
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Phone
                                          Number<i class="text-danger">*</i></label>
                                      <input type="text" id="phoneNumber" formControlName="phoneNumber" class="form-control rounded-pill"
                                          [class.is-invalid]="formErrors.phoneNumber" maxlength="12"
                                          (blur)="logValidationErrors(questionaireForm)" />
  
                                      <div [class.d-none]="!formErrors.phoneNumber">
                                          <small class="text-danger float-right" translate>{{formErrors.phoneNumber}}</small></div>
                                  </div>
                              </div>
                          </div>
                                 
                          <!-- Location and Sales Rep Section -->
                          <div class="mt-4 mb-3 p-2 bg-light rounded">
                              <h5 class="text-primary mb-3" style="font-family:'DINPro'">Location Information</h5>
                              
                              <div class="row w-100 d-flex justify-content-between p-2">
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Location<i class="text-danger">*</i></label>
                                      <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                          formControlName="branch" id="branch" name="branch"
                                          style="width: 100%;" tabindex="-1" aria-hidden="true" (change)='getSalesRep($event.target.value)'>
                                          <option *ngFor='let branch of branchs' value={{branch}}>{{branch}}</option>
                                      </select>
  
                                      <div [class.d-none]="!formErrors.branch">
                                          <small class="text-danger float-right" translate>{{formErrors.branch}}</small></div>
                                  </div>
  
                                  <div class="col-md-5 form-group py-2" *ngIf='branchselected'>
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>
                                          Sales Representative<i class="text-danger">*</i>
                                          <button class="rounded-pill mx-2 bg-dark text-white border-0 py-1 px-2" (click)="unassignSalesRep()" translate>Unassign</button>
                                      </label>
                                      <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                          formControlName="salesRep" id="salesRep" name="salesRep"
                                          style="width: 100%;" tabindex="-1" aria-hidden="true"
                                          (blur)="logValidationErrors(questionaireForm)">
                                          <!--<option value='0'>SELECT</option>-->
                                          <option *ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}</option>
                                      </select>
      
                                      <div [class.d-none]="!formErrors.salesRep">
                                          <small class="text-danger float-right">{{formErrors.salesRep}}</small></div>
                                  </div>
                              </div>
                          </div>
  
                          <!-- Client Information Section -->
                          <div class="mt-4 mb-3 p-2 bg-light rounded">
                              <h5 class="text-primary mb-3" style="font-family:'DINPro'">Client Information</h5>
                              
                              <div class="row w-100 d-flex justify-content-between p-2">
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Type of client</label>
                                      <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                          formControlName="describesYou" id="describesYou" name="describesYou"
                                          style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true">
                                          <option value="Builder">Builder</option>
                                          <option value="Designer">Contractor</option>
                                          <option value="Designer">Designer</option>
                                          <option value="Fabricator">Fabricator</option>
                                          <option value="Homeowner">Homeowner</option>
                                      </select>                             
                                  </div>
  
                                  <div class="col-md-5 form-group py-2">
                                      <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Age Group</label>
                                      <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                          formControlName="ageGroup" id="ageGroup" name="ageGroup" style="width: 100%; font-family:'DINPro'"
                                          tabindex="-1" aria-hidden="true">
                                          <option value="18-24">18 - 24</option>
                                          <option value="25-34">25 - 34</option>
                                          <option value="35-44">35 - 44</option>
                                          <option value="45-54">45 - 54</option>
                                          <option value="55-64">55 - 64</option>
                                          <option value="65-up">65 - up</option>
                                      </select>
                                  </div>
                              </div>    
  
                              <div class="form-group py-2 px-2"
                                  *ngIf="questionaireForm.get('describesYou').value=='Fabricator'|| questionaireForm.get('describesYou').value=='Designer'">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>
                                      What is the name of your company?
                                  </label>
                                  <input type="text" formControlName="companyName" class="form-control rounded-pill" />
                              </div>
                          </div>
  
                          <!-- Visit Information Section -->
                          <div class="mt-4 mb-3 p-2 bg-light rounded">
                              <h5 class="text-primary mb-3" style="font-family:'DINPro'">Visit Information</h5>
                              
                              <div class="form-group py-2 px-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Purpose of visit</label>
                                  <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                      formControlName="lookingFor" id="lookingFor" name="lookingFor"
                                      style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true">
                                      <option value="All">All</option>
                                      <option value="Cut To Size">Cut To Size</option>
                                      <option value="Payment">Payment</option>
                                      <option value="Place Order">Place Order</option>
                                      <option value="Porcelain/Engineered Slabs">Porcelain/Engineered Slabs</option>
                                      <option value="Plumbing accessories">Plumbing accessories</option>
                                      <option value="Samples">Samples</option>
                                      <option value="Slabs">Slabs</option>
                                      <option value="Slab/Tiles"> Slab/Tiles</option>
                                      <option value="Tiles">Tiles</option>                                        
                                      <option value="Wood">Wood</option>
                                  </select>
                              </div>
  
                              <div class="form-group py-2 px-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>How did you hear about us?</label>
                                  <!--<input type="text" formControlName="heardAboutUs" class="form-control" />-->
                                  <select class="form-control form-select select2tag select2-hidden-accessible rounded-pill"
                                      formControlName="heardAboutUs" id="heardAboutUs" name="heardAboutUs"
                                      style="width: 100%; font-family:'DINPro'" tabindex="-1" aria-hidden="true">
                                      <option value="Drive By">Drive By</option>
                                      <option value="Designer">Designer</option>
                                      <option value="Contractor"> Contractor</option>
                                      <option value="Fabricator">Fabricator</option>
                                      <option value="Family/Friends">Family/Friends</option>
                                      <option value="Social Media">Social Media</option>
                                      <option value="TV Ad">TV Ad</option>
                                      <option value="Boxing Week Sale">Boxing Week Sale</option>
                                  </select>
  
                                  <!--<div class="d-flex flex-wrap">
                                      <label class="m-2">
                                          <input class="mx-1" type="checkbox" [checked]="questionaireForm.controls['heardAboutUs'].value=='Drive By'"  (change)="questionaireForm.controls['heardAboutUs'].setValue('Drive By');heardAbout='Drive By';"/>Drive By
                                      </label>
                                      <label class="m-2">
                                      <input class="mx-1" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Designer'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Designer');heardAbout='Designer'"/>Designer
                                      </label>
                                      <label class="m-2">
                                          <input  class="mx-1"type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Contractor'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Contractor');heardAbout='Contractor'"/>Contractor
                                              </label>
                                              <label class="m-2">
                                           <input class="mx-1" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Fabricator'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Fabricator');heardAbout='Fabricator'"   />Fabricator
                                            </label>
                                            <label class="m-2">
                                           <input class="mx-1" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Family/Friends'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Family/Friends');heardAbout='Family/Friend'"/>Family/Friend
                                             </label>
                                           <label class="m-2">
                                          <input class="mx-1" type="checkbox"  [checked]="questionaireForm.controls['heardAboutUs'].value=='Social Media'" (change)="questionaireForm.controls['heardAboutUs'].setValue('Social Media');heardAbout='Social Media'"/>Social Media
                                           </label>
                                           <label class="m-2">
                                              <input  class="mx-1" type="checkbox"  [checked]="heardAbout=='Other'" (change)="questionaireForm.controls['heardAboutUs'].setValue('');heardAbout='Other'"/>Other
                                              
                                      </label>
                                      <input type="text" *ngIf="heardAbout=='Other'" formControlName="heardAboutUs" class="form-control" />
                                      </div>-->
                              </div>
  
                              <div class="form-group py-2 px-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>
                                      Are you with a fabricator? If yes, please indicate the name of the company.
                                  </label>
                                  <input type="text" formControlName="workWithFabricator" class="form-control rounded-pill" />
                              </div>
  
                              <div class="form-group py-2 px-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>
                                      Link (Website, Zoom, Ms Teams, etc)
                                  </label>
                                  <input type="text" formControlName="webLink" class="form-control rounded-pill" />
                              </div>
  
                              <div class="form-group py-2 px-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Tag</label>
                                  <input type="text" formControlName="tag" class="form-control rounded-pill" />
                              </div>
                              
                              <div class="form-group p-2">
                                  <label class="font-weight-bold p-2 rounded w-100 text-secondary" style="text-align: start;font-family:'DINPro'" translate>Notes</label>
                                  <textarea type="text" formControlName="notes" class="form-control rounded" rows="4"></textarea>
                              </div>
                          </div>
     
                          <div class="form-group m-4 text-center d-flex flex-column">
                              <div class="text-center">
                                  <button 
                                      [disabled]='!questionaireForm.valid || !questionaireForm.valid' (blur)="logValidationErrors(questionaireForm)"
                                      class="btn btn-primary text-white px-5 py-2 rounded-pill shadow-sm" (click)="onSubmit()" translate
                                      style="font-family:'DINPro'; cursor: pointer;">
                                      <i class="fa fa-check me-2"></i>Submit
                                  </button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Please wait...</h4>
                            </div>

                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Someone will be with you shortly.</h4>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" routerLink='/assets' data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>